import React, { useContext } from 'react';
import './App.css';
import { AuthContext } from './components/Login/AuthContext';
import CreateAvatar from './components/App/CreateAvatar';
import AvatarGallery from './components/App/AvatarGallery';
import PhotoManager from './components/App/PhotoManager';
import AppNavbar from './components/UI/AppNavbar';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';

function App() {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  // Add class to body for app pages
  React.useEffect(() => {
    if (location.pathname.startsWith('/app')) {
      document.body.classList.add('app-mode');
    } else {
      document.body.classList.remove('app-mode');
    }
  }, [location]);

  return (
    <div className="App">
      {location.pathname.startsWith('/app') && <AppNavbar />}
      
      <main className="app-main content-under-navbar">
        <Routes>
          <Route index element={<Navigate to="/app/create" replace />} />
          <Route path="create" element={<CreateAvatar />} />
          <Route path="upload" element={<PhotoManager />} />
          <Route path="gallery" element={<AvatarGallery />} />
          {/* Redirect to /app/create by default */}
          <Route path="*" element={<Navigate to="/app/create" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
